import { type Dispatch, useEffect } from 'react';
import { debounce } from 'ts-debounce';

import actions from '../prepackageActions';
import type { PrepackageSearchState } from '../prepackageDefaultState';
import { buildParams } from '../utils/buildParams';

type UsePrePackageFacetsProps = {
    state: PrepackageSearchState;
    dispatch: Dispatch<ReturnType<(typeof actions)[keyof typeof actions]>>;
    facetUrl: string;
};

export const usePrepackageFacets = ({ state, dispatch, facetUrl }: UsePrePackageFacetsProps) => {
    const getFacets = (): void => {
        const params = buildParams(state);
        dispatch(actions.getFacetsStarted(params));

        fetch(`${facetUrl}?${params}`, { method: 'GET' })
            .then((response) => response.json())
            .then((data) => dispatch(actions.getFacetsSuccess({ params, data })))
            .catch(() => dispatch(actions.getFacetsFailure(params)));
    };

    const debouncedGetFacets = debounce(getFacets, 350);

    useEffect(() => {
        debouncedGetFacets();
    }, [
        state.searchType,
        state.originAirport,
        state.destinationId,
        state.departureDate,
        state.returnDate,
        state.flexibleDeparture,
        state.duration,
        state.travelMonths,
    ]);
};
